<style scoped lang="scss">
	.header-row {
		background-color: #efefef;
		display: flex;
		flex-direction: row;
		.no {
			font-weight: bold;
			font-size: 13px;
			padding: 8px 0;
			text-align: center;
			width: 21%;
			border-right: solid 1px #dcdcdc;
		}
		.match {
			font-weight: bold;
			font-size: 13px;
			padding: 8px 0;
			text-align: center;
			width: 26%;
			border-right: solid 1px #dcdcdc;
		}
		.play {
			font-weight: bold;
			font-size: 13px;
			padding: 8px 0;
			text-align: center;
			width: calc(22% + 2px);
			border-right: solid 1px #dcdcdc;
		}
		.bet {
			font-weight: bold;
			font-size: 13px;
			padding: 8px 0;
			text-align: center;
			width: 29%;
		}
	}
	.bb {
		border-bottom: solid 1px #dcdcdc;
	}
	.match-row {
		display: flex;
		flex-direction: row;
		
		.no {
			width: 21%;
			text-align: center;
			font-size: 12px;
			border-right: solid 1px #dcdcdc;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			.total {
				color: #999999;
			}
			.week {
				font-weight: bold;
			}
			.halt {
				color: #999999;
			}
		}
		.match {
			padding: 5px 0;
			font-size: 12px;
			text-align: center;
			width: 26%;
			border-right: solid 1px #dcdcdc;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			.vs {
				font-size: 9px;
				font-weight: bold;
				color: #EB4C37;
			}
		}
		.match-lines {
			font-size: 12px;
			width: calc(52% + 1px);
			display: flex;
			flex-direction: row;
			.match-line-body {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: stretch;
				.bb {
					border-bottom: solid 1px #dcdcdc;
				}
				.match-line {
					display: flex;
					flex-direction: row;
					.play {
						width: 111px;
						border-right: solid 1px #dcdcdc;
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: center;
					}
					.bets {
						width: 150px;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						.bet-item {
							padding: 5px 0;
						}
						.red {
							color: #EB4C37;
						}
					}
				}
			}
			
		}
	}
	
</style>
<template>
	<div>
		
		<div class="header-row">
			<div class="no">场次</div>
			<div class="match">对阵</div>
			<div class="play">玩法</div>
			<div class="bet">投注</div>
		</div>
		<div class="match-row" :class="{'bb':index != matchList.length - 1}" v-for="(match, index) in matchList" :key="index">
			<div class="no">
				<div class="total">{{match.ended}}</div>
				<div class="week">{{match.issue_week}}</div>
				<div class="halt">{{match.half}}</div>
			</div>
			<div class="match">
				<div v-if="lotterySign != 'basketball'">
					<div>{{match.home}}</div>
					<div class="vs">VS</div>
					<div>{{match.away}}</div>
				</div>
				<div v-else>
					<div>{{match.away}}</div>
					<div class="vs">VS</div>
					<div>{{match.home}}</div>
				</div>
			</div>
			<div class="match-lines">
				<div class="match-line-body">
					<div style="display: flex; flex-direction: row; flex:1;" :class="{'bb':ind != match.betItems.length - 1}" v-for="(line, ind) in match.betItems" :key="ind">
						<div  class="match-line">
							<div class="play">
								<div>{{line[0].poolName}}</div>
							</div>
							<div class="bets">
								<div  v-for="(bets, indx) in line" :key="indx" :class="{'bet-item': true, 'red':bets.red == 1}">{{bets.betName}}({{bets.odds}})</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:['matchList', 'lotterySign'],
		name:"jcTable",
		data() {
			return {
				
			};
		}
	}
</script>
